/**
 * Scoped CSS for the onboarding surfaces — only the bits inline styles can't do
 * (hover/active affordances, the timeline connector pseudo-element, the hero
 * gradient halo, reduced-motion). All colors come from `--vn-*` tokens. Rendered
 * once per screen; duplicate <style> tags with identical content are harmless.
 */
export function OnboardingCss() {
  return <style>{CSS}</style>;
}

const CSS = `
.vn-ob-hero {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(120% 80% at 50% -10%,
      var(--vn-primary-subtle) 0%, transparent 60%),
    var(--vn-bg-surface);
}
.vn-ob-halo {
  position: relative;
  background: var(--vn-primary-subtle);
  color: var(--vn-primary-text);
  box-shadow: 0 0 0 6px color-mix(in srgb, var(--vn-primary-subtle) 55%, transparent);
}

/* Timeline: the vertical connector behind each marker (not the last). */
.vn-ob-step { position: relative; }
.vn-ob-step:not(:last-child) .vn-ob-marker::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  width: 2px;
  height: calc(100% + var(--vn-space-3) + var(--vn-space-3));
  background: var(--vn-border-default);
}
.vn-ob-step.is-done:not(:last-child) .vn-ob-marker::after {
  background: var(--vn-success-border);
}

/* Actionable rows get a hover lift + accent border. */
.vn-ob-row {
  transition: border-color var(--vn-duration-fast) var(--vn-ease-standard),
    box-shadow var(--vn-duration-fast) var(--vn-ease-standard),
    transform var(--vn-duration-fast) var(--vn-ease-standard);
}
.vn-ob-row.is-actionable:hover {
  border-color: var(--vn-primary-border);
  box-shadow: var(--vn-shadow-sm);
  transform: translateY(-1px);
}

@media (prefers-reduced-motion: reduce) {
  .vn-ob-row { transition: none; }
  .vn-ob-row.is-actionable:hover { transform: none; }
}
`;
